module.exports = __webpack_public_path__ + "img/special-coupon-img.c881aa47.png";